<router-outlet />
@if (loading$ | async) {
  <div class="loading-overlay">
    <div class="spinner-container">
      <mat-spinner [diameter]="50" color="primary" />
    </div>
  </div>
}
